import "@fancyapps/fancybox";
import "./foundation";
import "./fontAwesome";
// import "./chooseCity";
import "./carousels";
import "./handleInputNumber";
import "./stickyFooter";
import "./replaceImgSvg";
import "./lazyLoadVideo";
import "./customEqualizer";

import "../scss/style.scss";
(function ($) {
  "use strict";
  $(function () {
    // example
  });
})(jQuery);
